export default "__VITE_ASSET__DL_IqwkM__"